export enum UploadType {
  TOPICS = 'topic',
  VARIANTS = 'variant',
  VARIANTS_STREAM = 'variant_stream',
  CUSTOM_METRICS = 'custom_metric',
}

export type ImportType = 'csv' | 'pdf' | 'url';

export type WriteMode = 'append' | 'replace';
